export default __webpack_public_path__ + "static/media/logo-gestinet.af52d4eb.png";